import React, { useState } from "react";
import {
  FormControl,
  Grid,
  TextField,
  Typography,
  Button,
  Box,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import Loader from "../component/loading-screen/Loader";
import { apiErrorToast, ErrorToast } from "../utils/ToastUtil";

const BawanaInfra = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [formVisible, setFormVisible] = useState(false);
  const [amountValue, setAmountValue] = useState("");
  const [bawanaInfraId, setBawanaInfraId] = useState("");
  const [bawanaInfraPassword, setBawanaInfraPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedValue(value);
    setFormVisible(value !== "");
  };

  const handleSubmit = async () => {
    if (!selectedValue || !amountValue || !bawanaInfraId) {
      apiErrorToast("Please fill all the fields.");
      return;
    }

    // const payload = {
    //   provider: selectedValue,
    //   amount: amountValue,
    //   bawanaInfraId: bawanaInfraId,
    //   bawanaInfraPassword:bawanaInfraPassword
    // };
  };

  return (
    <Box
      sx={{
        p: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "#F7F4EF",
      }}
    >
      <Box
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 500,
          borderRadius: "16px",
          bgcolor: "white",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="h4"
          align="center"
          sx={{ fontWeight: "bold", color: "#D48628", mb: 2 }}
        >
          Bawana Infra Payment
        </Typography>
        <Box display="flex" justifyContent="center" my={2}>
          <Loader loading={loading} />
        </Box>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Select
            value={selectedValue}
            onChange={handleChange}
            displayEmpty
            sx={{ fontSize: "12px" }}
          >
            <MenuItem value="" disabled>
              Select Provider
            </MenuItem>
            <MenuItem value="Water Amt">Water Amt</MenuItem>
            <MenuItem value="CETP Amt">CETP Amt</MenuItem>
            <MenuItem value="Maintenance Amt">Maintenance Amt</MenuItem>
          </Select>
        </FormControl>

        {formVisible && (
          <>
            <Grid item xs={12} sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <TextField
                  label="Amount"
                  id="amount"
                  size="small"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontSize: "12px",
                      color: "black",
                    },
                  }}
                  value={amountValue}
                  onChange={(e) => setAmountValue(e.target.value)}
                  required
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <TextField
                  label="Bawana Infra ID"
                  id="bawanaInfraId"
                  size="small"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontSize: "12px",
                      color: "black",
                    },
                  }}
                  value={bawanaInfraId}
                  onChange={(e) => setBawanaInfraId(e.target.value)}
                  required
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <TextField
                  label="Bawana Infra Password"
                  id="bawanaInfraId"
                  size="small"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontSize: "12px",
                      color: "black",
                    },
                  }}
                  value={bawanaInfraPassword}
                  onChange={(e) => setBawanaInfraPassword(e.target.value)}
                  required
                />
              </FormControl>
            </Grid>
          </>
        )}

        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
            sx={{ width: "100%" }}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default BawanaInfra;
